import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Stack, Text } from '@hub-la/design-system';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ScheduleIcon from '@mui/icons-material/Schedule';
import moment from 'moment';
import 'moment/locale/pt-br';

const DateRange = ({
  startTime,
  endTime
}) => {
  const {
    palette
  } = useUtility();
  moment.locale('pt-br');
  const formatDate = () => {
    const start = moment(startTime);
    const dayOfWeek = start.format('dddd');
    const date = start.format('D [de] MMMM').toLowerCase();
    return `${dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1).replace('-feira', '')}, ${date}`;
  };
  const formatHoursRange = () => {
    const start = moment(startTime);
    const end = moment(endTime);
    const startDate = start.format('HH:mm');
    const endDate = end.format('HH:mm');
    return `${startDate} às ${endDate}`;
  };
  return jsxs(Stack, Object.assign({
    direction: "row",
    gap: 2,
    py: 6,
    alignItems: "center"
  }, {
    children: [jsx(DateRangeIcon, {
      fontSize: "small",
      style: {
        color: palette('outline')
      }
    }), jsx(Text, Object.assign({
      color: "onSurfaceVariant",
      variant: "body1",
      paddingRight: 2
    }, {
      children: formatDate()
    })), jsx(ScheduleIcon, {
      fontSize: "small",
      style: {
        color: palette('outline')
      }
    }), jsx(Text, Object.assign({
      color: "onSurfaceVariant",
      variant: "body1"
    }, {
      children: formatHoursRange()
    }))]
  }));
};

export { DateRange };
